import { render, staticRenderFns } from "./add-cost.vue?vue&type=template&id=ad09cd34&scoped=true"
import script from "./add-cost.vue?vue&type=script&lang=ts"
export * from "./add-cost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad09cd34",
  null
  
)

export default component.exports